import { PasswordRequirements } from '@mortgage-pos/ui/components/PasswordRequirements'
import React, {
  ChangeEventHandler,
  FocusEventHandler,
  FC,
  useCallback,
  useState,
} from 'react'

interface Props {
  name: string
  value: string
  title?: string
  onChange: ChangeEventHandler<HTMLInputElement>
  onBlur?: FocusEventHandler<HTMLInputElement>
}

const PasswordInput: FC<Props> = ({
  name,
  value,
  title,
  onChange,
  onBlur = (e) => {},
}) => {
  const [showPassword, setShowPassword] = useState(false)

  const handleChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (e) => {
      const newEvent: React.ChangeEvent<HTMLInputElement> = {
        ...e,
        target: {
          ...e.target,
          name,
          value: e.target.value,
        },
      }
      onChange(newEvent)
    },
    [name, onChange]
  )

  return (
    <>
      <div className="input__pass-wrapper">
        <div className="input__pass-input-wrapper">
          <input
            type={showPassword ? 'text' : 'password'}
            value={value}
            autoComplete="new-password" // Disables autocomplete for password fields
            name={name}
            className="input__field"
            onChange={handleChange}
            onBlur={onBlur}
            title={title}
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="input__pass-show-button fs-exclude"
          >
            {showPassword ? 'Hide' : 'Show'}
          </button>
        </div>
      </div>

      <PasswordRequirements password={value} />
    </>
  )
}

export default PasswordInput
